import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { Spinner } from './shared/components/ui/spinner/spinner';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lonniyire-root',
  imports: [RouterOutlet, TranslocoDirective, Spinner],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private router = inject(Router);
  protected readonly isNavigating = computed(() => !!this.router.currentNavigation());
  protected readonly title = signal('lonniyire-client');
}
